import { useNavigate } from 'react-router-dom'
import { Settings, BookOpen, ChevronRight, Shield, Megaphone } from 'lucide-react'
import Layout from '../../components/Layout'
import { useAuth } from '../../context/AuthContext'
import { useT } from '../../i18n'

export default function MorePage() {
  const navigate = useNavigate()
  const { user, isSuperadmin } = useAuth()
  const lang = user?.language ?? 'ru'
  const tr = useT(lang)

  const items = [
    { icon: <Megaphone size={20} />, label: 'Рассылка клиентам', path: '/admin/broadcast' },
    { icon: <Settings size={20} />, label: tr('settings'), path: '/admin/settings' },
    { icon: <BookOpen size={20} />, label: tr('registry'), path: '/admin/registry' },
    ...(isSuperadmin ? [{ icon: <Shield size={20} />, label: 'Администраторы', path: '/admin/admins' }] : []),
  ]

  return (
    <Layout title={tr('more')}>
      <div className="flex flex-col gap-2">
        {items.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="card flex items-center gap-3 w-full text-left active:opacity-70"
          >
            <span className="text-tg-hint">{item.icon}</span>
            <span className="flex-1 font-medium text-tg-text">{item.label}</span>
            <ChevronRight size={16} className="text-tg-hint" />
          </button>
        ))}
      </div>

      <div className="mt-6 card">
        <p className="text-xs text-tg-hint text-center">Ansor Nasiya Admin Panel</p>
        {user && <p className="text-xs text-tg-hint text-center mt-0.5">{user.full_name} · {user.role}</p>}
      </div>
    </Layout>
  )
}
